var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
export var NavLoadingContext = React.createContext({
  isLoading: false,
  setLoading: function setLoading(isLoading) {}
}); // This is a PureComponent so that setting state to loading
// when it is already loading won't cause a re-render

var NavLoading =
/** @class */
function (_super) {
  __extends(NavLoading, _super);

  function NavLoading(props) {
    var _this = _super.call(this, props) || this;

    _this.setLoading = function (isLoading) {
      _this.setState({
        isLoading: isLoading
      });
    };

    _this.state = {
      isLoading: false,
      setLoading: _this.setLoading
    };
    return _this;
  }

  NavLoading.prototype.render = function () {
    return React.createElement(NavLoadingContext.Provider, {
      value: this.state
    }, this.props.children(this.state.isLoading));
  };

  return NavLoading;
}(React.PureComponent);

export { NavLoading };